module.exports = __webpack_public_path__ + "static/img/13.b5fe159.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/13.png
// module id = I5vq
// module chunks = 1